"use client";

import React from "react";
import { ArrowUp, Facebook, Instagram, Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="166068" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-foreground/10 animate-pulse rounded" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <div className="flex flex-col gap-3">
        <Link to="/HomePage" className="text-foreground/70 hover:text-foreground transition-colors text-xs uppercase tracking-widest font-sans">Home</Link>
        <Link to="/BeautyPage" className="text-foreground/70 hover:text-foreground transition-colors text-xs uppercase tracking-widest font-sans">Beauty</Link>
        <Link to="/AestheticsPage" className="text-foreground/70 hover:text-foreground transition-colors text-xs uppercase tracking-widest font-sans">Aesthetics</Link>
        <Link to="/MassagePage" className="text-foreground/70 hover:text-foreground transition-colors text-xs uppercase tracking-widest font-sans">Massage</Link>
      </div>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-foreground/70 hover:text-foreground transition-colors text-xs uppercase tracking-widest font-sans">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Instagram,
    label: "Instagram",
    href: "https://www.instagram.com/natalias.beauty/"
  }, {
    icon: Facebook,
    label: "Facebook",
    href: "https://www.facebook.com/NataliaasBeauty"
  }];
  return <section id="footer" className="bg-secondary text-foreground pt-16 pb-8 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col items-start space-y-6">
            <Link to="/HomePage" className="inline-block opacity-90 hover:opacity-100 transition-opacity">
              <img src="/img/think_power_logo_cream.png" alt="Natalia's Beauty" className="h-7 w-auto object-contain grayscale brightness-50" />
            </Link>
            <p className="text-foreground/70 text-sm leading-relaxed max-w-xs font-sans italic">
              Refined aesthetics and holistic beauty rituals in the heart of Brooke, Norwich. Experience the art of quiet luxury.
            </p>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-lg font-serif italic tracking-wider text-foreground">Explore</h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-lg font-serif italic tracking-wider text-foreground">The Sanctuary</h3>
            <div className="flex flex-col space-y-4 text-sm text-foreground/70 font-sans">
              <p className="leading-relaxed pr-4">
                Discover bespoke treatments tailored to your skin's unique journey. Visit our sanctuary in Brooke for a consultation.
              </p>
              <Button asChild variant="outline" className="w-fit bg-transparent border-border text-foreground hover:bg-accent/40 hover:text-foreground rounded-lg uppercase text-[10px] tracking-widest px-6">
                <Link to="tel:07766733976">Book Treatment</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-lg font-serif italic tracking-wider text-foreground">Connect</h3>
            <div className="flex items-center gap-4">
              {socialLinks.map((social, i) => <Link key={social.label} data-index={i} to={social.href} className="p-2.5 rounded-lg bg-background/50 border border-border/10 hover:bg-accent/60 text-foreground transition-all duration-300 shadow-sm" aria-label={social.label}>
                  <social.icon className="size-4" strokeWidth={1} />
                </Link>)}
            </div>
          </div>
        </div>

        {}
        <div className="flex flex-col pt-8 border-t border-border/30">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-[10px] uppercase tracking-widest text-foreground/50 text-center sm:text-left font-sans">
              © {currentYear} Natalia's Beauty. Privacy & Terms.
            </p>
            <Button variant="ghost" size="sm" onClick={scrollToTop} className="text-foreground/60 hover:text-ring hover:bg-transparent gap-2 rounded-lg px-4 group transition-colors">
              <span className="text-[10px] uppercase tracking-widest font-sans">Back to Top</span>
              <ArrowUp className="size-4 text-ring group-hover:-translate-y-1 transition-transform" strokeWidth={1.5} />
            </Button>
          </div>
        </div>
      </div>
    </section>;
}